export const SEND = 'send';
export const RESET = 'reset';
